export default __webpack_public_path__ + "assets/icon-google-circles-communities.61b1e0f1.webp";